import type { ComponentProps } from "react"

export default function MapLegend(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.50012 8C3.32854 8 4.00012 7.32843 4.00012 6.5C4.00012 5.67157 3.32854 5 2.50012 5C1.67169 5 1.00012 5.67157 1.00012 6.5C1.00122 7.32797 1.67215 7.9989 2.50012 8ZM2.50012 6C2.77626 6 3.00012 6.22386 3.00012 6.5C3.00012 6.77614 2.77626 7 2.50012 7C2.22397 7 2.00012 6.77614 2.00012 6.5C2.00012 6.22386 2.22397 6 2.50012 6ZM4.00012 1H1.00012V4H4.00012V1ZM3.00012 3H2.00012V2H3.00012V3ZM4.00012 9H1.00012V12H4.00012V9ZM3.00012 11H2.00012V10H3.00012V11ZM6.00012 6H13.0001V7H6.00012V6ZM2.49012 13L4.12812 16H0.870117L2.49012 13ZM15.0001 2V3H6.00012V2H15.0001ZM6.00012 10H11.0001V11H6.00012V10ZM6.00012 14H9.00012V15H6.00012V14Z"
        fill={fill}
      />
    </svg>
  )
}
